import { MODULE_NAME } from 'src/app/helper/class/app-constant';
import { isArray, isExistsKey } from 'src/app/helper/class/utilityHelper';
import { tblFilter } from 'src/app/helper/interface/response';
import {
  actionInterface,
  Concrete,
  dynamicRoleKey,
  moduleInterface,
  roleKey,
  roleMap,
  User,
  userPermission,
} from 'src/app/helper/interface/user';

export class RolePermissionService {
  module = MODULE_NAME;
  userRoleData: roleMap = {} as roleMap;
  user_data: User = {} as User;
  constructor() {}

  checkPermission(
    mName: Concrete<keyof moduleInterface> | Concrete<keyof moduleInterface>[],
    aName: Concrete<keyof actionInterface> | Concrete<keyof actionInterface>[]
  ) {
    if (mName == undefined || aName == undefined) {
      return false;
    }
    if (aName == 'MY_SELF') {
      return +(this.user_data?.staff_fk_id || 0) > 0 ? true : false;
    }
    const modules = Array.isArray(mName) ? mName : [mName];
    const actions = Array.isArray(aName) ? aName : [aName];

    for (const mod of modules) {
      for (const act of actions) {
        if (
          isExistsKey(this.userRoleData, [mod, 'actions', act]) &&
          this.userRoleData[mod]['actions'][act]
        ) {
          return true; // Permission found
        }
      }
    }
    return false;

    // const action: any = isArray(aName) ? aName : [aName],
    //   res = {};
    // action.forEach((e: any) => {
    //   res[e] = false;
    //   const s = isExistsKey(this.userRoleData, [mName, e]);
    //   if (s) {
    //     res[e] = this.userRoleData[mName][e];
    //   }
    // });
    // return Object.values(res)?.filter((a: any) => a == true).length ? true : false;
  }

  getModuleByAction(aName: Concrete<keyof actionInterface>[]): any {
    return Object.keys(this.userRoleData).filter(
      (a: any) =>
        aName.filter(
          (e: string) => isExistsKey(this.userRoleData, [a,'actions', e]) == true
        ).length > 0
    );
    //return this.mapTblFilter(res)
  }

  getPermittedId(
    mName: Concrete<keyof moduleInterface>[],
    aName: Concrete<keyof actionInterface>[],
    keys: roleKey[] = []
  ) {
    const res: any = [];
    if (mName.length) {
      mName.map((mN: any) => {
        aName.forEach((aN) => {
          if (isExistsKey(this.userRoleData, [mN, 'actions',aN])) {
            if (keys.length) {
              keys.map((a) => {
                const p: any = this.userRoleData[mN].permission[a] || '';
                let sp: any = [];
                if (p.includes('All')) {
                  sp.push(0);
                } else {
                  if (isArray(p)) {
                    //sp.push(p.join(','))
                    sp = p;
                  } else sp.push(+p);
                }
                const index = res.findIndex((b) => b.colName == a);
                if (index > -1) {
                  const oldvalue = res[index];
                  res[index].value =
                    isArray(sp) && isArray(oldvalue.value)
                      ? [...sp, ...oldvalue.value]
                      : sp;
                } else {
                  const s: tblFilter = { colName: a, value: sp };
                  res.push(s);
                }
              });
            }
          }
        });
      });
    }
    return res;
  }

  getPermittedData(
    mName: Concrete<keyof moduleInterface>[],
    aName: Concrete<keyof actionInterface>[],
    keys: roleKey[] = []
  ) {
    let d: any = this.getPermittedId(mName, aName, keys);
    if (Array.isArray(d)) {
      d.forEach((e: any, i) => {
        const v = isArray(e.value) && e.value[1] ? e.value : `${e.value[0]}`;
        const searchArray = (isArray(v) ? v : v.split(',')).filter(
          (a: any) => a
        );
        const containAll = searchArray.filter((item: any) =>
          ['-1', '0', 0, ''].includes(item)
        );
        if (containAll.length || !searchArray.length) {
          d[i].value = [];
        } else {
          d[i].value = searchArray;
        }
      });
      return d;
    } else {
      return [];
    }
  }
  async mapRolePermission(
    p: Array<userPermission> | userPermission,
    userData: User
  ) {
    const x: Array<userPermission> = Array.isArray(p) ? p : [p];
    const roleP: roleMap = {} as roleMap,
      my_self =
        userData.staff_fk_id && +userData.staff_fk_id > 0 ? true : false;
    await x.forEach((obj: userPermission) => {
      if (!roleP[obj.moduleName]) {
        roleP[obj.moduleName] = {} as dynamicRoleKey;
        roleP[obj.moduleName].permission = {
          zone: [],
          department: [],
          institution: [],
          promotional_office: [],
          region: [],
          ad_office: [],
          trust: [],
          sponsorship_module: [],
          church: [],
          home: [],
          child_type: [],
          payroll_group_fk_id: [],
        };
      }
      roleP[obj.moduleName].MY_SELF = my_self;
      const aN: any = isArray(obj.actionName)
        ? obj.actionName[0]
        : obj.actionName;
      roleP[obj.moduleName][aN] = true;
      for (const [key, value] of Object.entries(
        roleP[obj.moduleName].permission
      )) {
        if (obj.hasOwnProperty(key)) {
          // @ts-ignore
          const v = +obj[key] == 0 || +obj[key] == -1 ? 'All' : +obj[key];
          if (!value.includes(v) && v) {
            value.push(v);
          }
        }
      }
    });
    if (roleP?.CHILD?.permission) {
      const s = roleP.CHILD.MANAGE_MK_CHILD || false,
        h = roleP.CHILD.MANAGE_HOME_CHILD || false;
      if (s && h) {
        roleP.CHILD?.permission?.child_type?.push('All');
      } else {
        const re: any = s ? 1 : 2;
        roleP.CHILD.permission.child_type?.push(re);
      }
    }
    if (roleP?.SPONSORSHIP?.permission) {
      const s = roleP.CHILD?.MANAGE_MK_CHILD || false,
        h = roleP.CHILD?.MANAGE_HOME_CHILD || false;
      if (
        roleP.CHILD?.MANAGE_MK_CHILD != undefined ||
        roleP.CHILD?.MANAGE_HOME_CHILD != undefined
      ) {
        if (s && h) {
          roleP.SPONSORSHIP?.permission?.child_type?.push('All');
        } else {
          const re: any = s ? 1 : 2;
          roleP.SPONSORSHIP.permission.child_type?.push(re);
        }
      }
    }
    if (my_self) {
      ['STAFF', 'APPLICATION', 'MONTHLY_REPORT_STAFF', 'PAYSLIP'].forEach(
        (e) => {
          if (roleP[e] == undefined) {
            roleP[e] = { permission: {}, MY_SELF: my_self };
          } else {
            roleP[e].MY_SELF = my_self;
          }
        }
      );
    }
    return roleP;
  }
}
